module.exports = {
  title: '客户黑名单',
  route: {
    path: '/content-manage',
    children: {
      path: 'market-sms-black-list',
    },
  },
};
